import {useState, useEffect} from "react";
// import {Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import Line from "./Charts/Line";
import Bar from "./Charts/Bar";
import {useSelector, useDispatch} from "react-redux";
import {
	ListarPorPeriodoMains,
	TableMeans,
	cleanDataChart
} from "../actions/proyects.actions";
import {Table} from "react-bootstrap";
// import JSONPretty from 'react-json-pretty'

const Mains = ({
	CodProyect,
	CodPc,
	classification,
	CodMeans,
}) => {
	const dispatch = useDispatch();
	const proyects = useSelector((state) => state.proyects);
	const auth = useSelector(state => state.auth);
	const [loading, setLoading] = useState(true);
	const [change, setChange] = useState(true);

	useEffect(() => {
		setLoading(true);
		if (!change) {
			dispatch(
				ListarPorPeriodoMains(CodProyect, CodPc, classification, CodMeans, '0', auth.scaleSelected, auth.dateSelected)
			);
		} else {
			dispatch(
				ListarPorPeriodoMains(CodProyect, CodPc, classification, CodMeans, '1', auth.scaleSelected, auth.dateSelected)
			);
		}
		dispatch(TableMeans(CodProyect, CodPc, classification, CodMeans, auth.scaleSelected, auth.dateSelected));
		setLoading(false);
		// eslint-disable-next-line
	}, [CodMeans, auth.dateSelected]);
 
	const callChartBar = (data) => {
		dispatch(cleanDataChart())
		if (!data) {
			dispatch(
				ListarPorPeriodoMains(CodProyect, CodPc, classification, CodMeans, '0', auth.scaleSelected, auth.dateSelected)
			);
		} else {
			dispatch(
				ListarPorPeriodoMains(CodProyect, CodPc, classification, CodMeans, '1', auth.scaleSelected, auth.dateSelected)
			);
		}
		setChange(data);
	};

	return (
		<div>
		{/* <button onClick={handlePrint}>Print this out!</button> */}

			{proyects.graphic && proyects.graphic[0] ? (
				<>
					{change ? (
						<Line
							data={proyects.graphic}
							className="responsive-chart"
						/>
					) : (
						// </Link>
						<Link
							to="#"
						>
							<Bar
								data={proyects.graphic}
								className="responsive-chart"
							/>
						</Link>
					)}

					{/* <JSONPretty data={proyects.graphic} /> */}
				</>
			) : (
				<Line className="responsive-chart" data={proyects.graphic} />
			)}
			{proyects.meansTable ? (
				<>
					<Table
						striped
						bordered
						hover
						width="100%"
						responsive
						size="sm"
						className="mt-3 bg-white"
					>
						<thead>
							<tr>
								<th className="d-flex justify-content-around">
									Insumo
									<div className="headTable">
										<span
											style={{marginRight: '15px'}}
											className={change && "chartIcon"}
											onClick={() => callChartBar(true)}
										>
											<i className="fas fa-chart-area"></i>
										</span>

										{change ? (
											<span
												onClick={() =>
													callChartBar(false)
												}
											>
												<i className="fas fa-chart-bar"></i>
											</span>
										) : (
											<span
												className="chartIcon"
												onClick={() =>
													callChartBar(false)
												}
											>
												<i className="fas fa-chart-bar"></i>
											</span>
										)}
									</div>
								</th>
								<th>Unidad</th>
								<th>Presupuesto</th>
								<th>Programado</th>
								<th>Valorizado</th>
								<th>Real</th>
							</tr>
						</thead>

						<tbody>
							{proyects.meansTable.map((items) => (
								<tr key={items.CodInsumo}>
									<td className="text-capitalize fs-5">
										{items.DesInsumo}
									</td>
									<td className="text-right">{items.Unidad}</td>
									<td className="text-right">
										{Intl.NumberFormat("en").format(
											items.PresupuestoParcial
										)}
									</td>
									<td className="text-right">
										{Intl.NumberFormat("en").format(
											items.ProgramadoParcial
										)}
									</td>
									<td className="text-right">
										{Intl.NumberFormat("en").format(
											items.ValorizadoParcial
										)}
									</td>
									<td className="text-right">
										{Intl.NumberFormat("en").format(
											items.RealParcial
										)}
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</>
			) : loading ? (
				"Cargando..."
			) : (
				"Sin datos"
			)}
		</div>
	);
};

export default Mains;
